<span class="thumbnail-presence-wrapper">
<div pRipple class="thumbnail thumbnail-{{size}} {{classList}}" style="{{stylesList}}" [ngClass]="{
      'rounded-circle': circle,
      'img-thumbnail': bordered
    }">
  <img *ngIf="imgSrc" alt="thumbnail" [src]="imgSrc" [width]="pixelSize" [height]="pixelSize"
    [ngClass]="{'rounded-circle': circle}">
  <p-skeleton *ngIf="!imgSrc" width="100%" height="100%" shape="circle"></p-skeleton>
</div>
  <p-badge *ngIf="isOnline" role="img" severity="success" class="thumbnail-presence-dot" styleClass="p-badge-dot"
    [style]="{width: '.85rem', height: '.85rem', minWidth: '.85rem', padding: '0', borderRadius: '50%', boxSizing: 'border-box', border: '2px solid var(--surface-card, #fff)'}"
    [attr.aria-label]="'realtime.online' | translate" [pTooltip]="'realtime.online' | translate"></p-badge>
</span>
